import DisabledPage from "../../../disabled-page/disabledPage";
import { AppPage } from "../../../_common/components/app-page";
import { CF } from "../../../_common/layout";
import { h, Fragment } from "preact";
import { t } from "../../../_i18n";
import {
    getTermsPueCertificates,
    getAccountPueCertificatesStudentIdWithSlots,
    postAccountAcceptTermsPueCertificates,
    postAccountPueCertificatesEnroll,
} from "../../../_rx/enrollment/certificados-pue/actions/index";
import { connect } from "react-redux";
import { useEffect, useState } from "preact/hooks";
import Loading from "../../../_common/components/loading/Loading";
import Card from "../components/Card";
import Terms from "../components/Terms";

function CertificadosPUE({
    studentId,
    certificadosPueState,
    condicionesCertificadosPueState,
    getTermsPueCertificates,
    getAccountPueCertificatesStudentIdWithSlots,
    postAccountAcceptTermsPueCertificates,
    postAccountPueCertificatesEnroll,
}) {
    /** Variables **/
    const [selectedId, setSelectedId] = useState(null);
    const [detalleId, setDetalleId] = useState(null);
    const [loadingCertBuy, setLoadingCertBuy] = useState(false);

    /** Lifecycles **/
    useEffect(() => {
        getTermsPueCertificates(studentId);
    }, []);

    /** Methods **/
    const handleAcceptTerms = () => {
        postAccountAcceptTermsPueCertificates(studentId);
    };

    const handleBuy = async ({ certificate, event, eventCalendar }) => {
        const payload = {
            "inlineObject8": {
                pue_certificate_id: certificate?.id,
                attempt_id: certificate?.attempt?.id,
                event_id: event?.id,
                event_calendar_id: eventCalendar?.id,
                formative_action_id: certificate?.formative_action?.id,
                cost: certificate?.attempt?.cost,
            }
        };
        setLoadingCertBuy(true);

        try {
            const { data } = await postAccountPueCertificatesEnroll(studentId, payload);
            if (data.refresh) {
                setDetalleId(null);
                setSelectedId(null);
                try {
                    await getAccountPueCertificatesStudentIdWithSlots(studentId);
                } finally {
                    setLoadingCertBuy(false);
                }
            } else {
                if (data.cart_url) window.location.href = data.cart_url;
            }
        } catch {
            setLoadingCertBuy(false);
        }
    };

    /** Render **/
    if (loadingCertBuy || (!condicionesCertificadosPueState && !certificadosPueState))
        return (
            <CF className="max-width-980">
                <Loading label={`${t('Cargando')}. . . `} />
            </CF>
        );

    if (
        condicionesCertificadosPueState &&
        !condicionesCertificadosPueState.student_signed_permission
    )
        return (
            <CF className="max-width-980">
                {
                    condicionesCertificadosPueState &&
                    <Terms
                        data={condicionesCertificadosPueState}
                        acceptTerms={handleAcceptTerms}
                    />
                }
            </CF>
        );

    return (
        <CF className="max-width-980">
            {condicionesCertificadosPueState?.student_signed_permission && (
                <Fragment>
                    <h1 className="hero">{t("Certificados PUE")}</h1>
                    <div className="card-dashboard-full-width no-padding full-width cursor-default">
                        <div className="p-top" />
                        {certificadosPueState?.map((certificadoPueState) => {
                            return (
                                <Card
                                    certificate={certificadoPueState}
                                    check={selectedId === certificadoPueState?.id}
                                    setCheck={(e) => setSelectedId(e)}
                                    detail={detalleId === certificadoPueState?.id}
                                    setDetail={(e) => setDetalleId(e)}
                                    setBuy={(e) => handleBuy(e)}
                                />
                            );
                        })}
                    </div>
                </Fragment>
            )}
        </CF>
    );
}

/** Redux **/
CertificadosPUE = connect(
    ({ enrollmentCertificados, auth }) => ({
        studentId: auth.loggedUser.id,
        certificadosPueState: enrollmentCertificados.certificadosPueState,
        condicionesCertificadosPueState:
            enrollmentCertificados.condicionesCertificadosPueState
    }),
    {
        getTermsPueCertificates,
        getAccountPueCertificatesStudentIdWithSlots,
        postAccountAcceptTermsPueCertificates,
        postAccountPueCertificatesEnroll,
    }
)(CertificadosPUE);

/** Export Default **/
export default ({ ...rest }) => {
    const disabled = false;
    return (
        <AppPage className="max-width">
            {disabled && <DisabledPage />}
            {!disabled && <CertificadosPUE {...rest} />}
        </AppPage>
    );
};
